import { StatusType as StatusTypeEnum, TIMELINE_STATUS_COLORS } from '../constants/index';
import {
  CheckCircle as CheckCircleIcon,
  PlayArrow as PlayIcon,
  Schedule as ScheduleIcon,
  Close as ErrorIcon,
  Height,
} from '@material-ui/icons';
// Status icons mapping
export const statusIcons = {
  [StatusTypeEnum.COMPLETED]: CheckCircleIcon,
  [StatusTypeEnum.PENDING]: ScheduleIcon,
  [StatusTypeEnum.ERROR]: ErrorIcon
};

export const statusColors = TIMELINE_STATUS_COLORS;

// Size colors for metadata chips - deprecated, use SIZE_COLORS from constants
export const sizeColors = {
  'XS': { bgcolor: 'success.light', color: 'success.dark' },
  'S': { bgcolor: 'info.light', color: 'info.dark' },
  'M': { bgcolor: 'warning.light', color: 'warning.dark' },
  'L': { bgcolor: 'error.light', color: 'error.dark' },
  'XL': { bgcolor: 'error.main', color: 'error.contrastText' }
} as const;

// Time constants in milliseconds
export const TIME_CONSTANTS = {
  ONE_MINUTE: 60 * 1000,
  THIRTY_MINUTES: 30 * 60 * 1000,
  ONE_HOUR: 60 * 60 * 1000,
  TWO_HOURS: 2 * 60 * 60 * 1000,
  THREE_HOURS: 3 * 60 * 60 * 1000,
  TWELVE_HOURS: 12 * 60 * 60 * 1000,
  ONE_DAY: 24 * 60 * 60 * 1000
} as const;

// Layout and positioning constants
export const LAYOUT_CONSTANTS = {
  TIME_RANGE_PADDING_PERCENTAGE: 0.1, // 10% padding on each side of time range
  MILESTONE_POSITION_OFFSET_SMALL: 0.005, // 0.5% offset for milestone positioning
  MILESTONE_POSITION_OFFSET_LARGE: 0.1, // 10% offset for milestone positioning
  MINIMUM_TIME_PADDING: TIME_CONSTANTS.ONE_HOUR // Minimum 1 hour padding
} as const;

export enum PrimitiveName {
  SDO = 'SDO',
  SCI = 'SCI',
  SCI_DELTA = 'SCI-DELTA',
  DTP = 'DTP',
  DTP_DELTA = 'DTP-DELTA',
  AGI = 'AGI',
  SDO_ThirdParty = 'SDO-ThirdParty',
}

export const primitiveColors: Record<string, string> = {
   [PrimitiveName.SDO]: '#2196f3',
   [PrimitiveName.SCI_DELTA]: '#4caf50',
   [PrimitiveName.DTP]: '#ff8f00',
   [PrimitiveName.DTP_DELTA]: '#7e57c2',
  [PrimitiveName.SDO_ThirdParty]:'#8FD6F2'
};

export const primitiveDisplayNames: Record<string, string> = {
   [PrimitiveName.SCI]: PrimitiveName.SCI_DELTA,
   [PrimitiveName.AGI]: PrimitiveName.SDO_ThirdParty,
};

export const skeletonConfig = {
  timeMarkers: {
    count: 7,
    dimensions: { width: 40, height: 20 }
  },
  milestones: {
    count: 3,
    spacing: 25,
    textDimensions: { width: 80, height: 16},
    verticalLineDimensions: { width: 2, height: 40, marginTop: 4}
  }
};